<template>
  <div class="hello">
    <b-row>
    <Header />
    <b-col cols="2" class="left-side"><HistoryNav /></b-col>
    <b-col class="right-side"><Requisition /></b-col>
  </b-row>
  </div>
</template>

<script>
import Header from './Header.vue'
import HistoryNav from './HistoryNav.vue'
import Requisition from './Requisition.vue'

export default {
  name: 'Layout',
  components: {
    Header,
    HistoryNav,
    Requisition
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.left-side{
  height: auto;
  border: 2px inset;
  overflow: auto;
}
.right-side{
  height: auto;
  border: 2px inset;
  margin-left: 2px;
  background: #fff;
}
</style>
